<template>
    <div>
        <Header :logged="logged" />
        <div id="jornal-eletronico">
            <h1>Jornal Eletrônico</h1>
            <div class="jornal-eletronico-estados">
                <div class="jornal-eletronico-estado" v-for="UF of estados" :key="UF.ID" @click="true">
                    <figure>
                        <div>
                            <img :src="require('@/assets/imgs/bandeiras/flag-'+(UF.Sigla).toLowerCase()+'.png')" :alt="UF.Sigla">
                            <figcaption>{{ UF.Nome }}</figcaption>
                        </div>
                    </figure>
                </div>
            </div>
        </div>
        <footersite class="d-none d-xl-block" />
        <footersitemobile class="d-block d-xl-none"/>
    </div>
</template>
<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import Header from '../components/Header'
import Estados from '../services/estados'
import API from '../services/api'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";

  

export default {
  components: {
    Header,
    BeatLoader,
    footersite,
    footersitemobile,
  },
  methods: {
  },
  data() {
    return {
      estados: {},
      logged: false,
    }
  },
  mounted() {
    this.estados = Estados

    this.$root.isLogged().then(() => {
      this.logged = true
    }).catch(() => {
      this.logged = false
    })
  },
}
</script>

<style scoped>
#jornal-eletronico{padding-top: 75px;padding-bottom: 90px;margin-top: 120px; margin-bottom: 37px;display: flex;flex-flow: column;align-items: center;justify-content: center;}
#jornal-eletronico h1{font: normal normal bold 30px/41px 'Kanit', sans-serif;color: #597EB5;margin-bottom: 40px;}
#jornal-eletronico .jornal-eletronico-estados {display: flex;flex-wrap: wrap;align-items: center;gap: 50px 30px;justify-content: center;max-width: 1170px;margin: 0 auto;}
#jornal-eletronico .jornal-eletronico-estados .jornal-eletronico-estado{width:220px;height:150px;box-shadow: 0px 2px 10px 0px rgb(110 130 208 / 30%);display: flex;align-items: center;justify-content: center;text-align: center;cursor: pointer;}
#jornal-eletronico .jornal-eletronico-estados .jornal-eletronico-estado figure{margin: 0;}
#jornal-eletronico .jornal-eletronico-estados .jornal-eletronico-estado figcaption{font: normal normal bold 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-top: 10px;}
@media (max-width:1199px){
    
    #jornal-eletronico{margin-top: 68px;margin-left: 17px;margin-right: 17px;max-width: 100%;}
}
</style>